module.exports = __webpack_public_path__ + "media/images/payments/bitcoin-dark-3e29b66814026d8ed111806f1dd34ae4.svg";